import React from 'react';
import ReactDOM from 'react-dom';
import '@src/common/resetPC.css';
import Layout from './layout';

/* eslint-disable */
ReactDOM.render(<Layout pageData={allData} />, document.getElementById('root'));
/* eslint-enable */

